import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { UtilService } from '../../../services/util.service';
import { PreguntaDTO } from '../../../dto/encuesta/preguntas.dto';
import { OpcionRespuestaDto } from '../../../dto/encuesta/opcion-respuesta.dto';
import { FormField, FormFieldOption } from '../../../dto/util/form-field';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncuestaService } from '../../../services/encuesta.service';
import { EncuestaDTO } from '../../../dto/encuesta/encuesta.dto';
import { TranslateService } from '@ngx-translate/core';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-preguntas',
  templateUrl: './preguntas.component.html',
  styleUrl: './preguntas.component.scss',
})
export class PreguntasComponent implements OnInit {
  @Input() public isNewItem: any;

  public preguntaForm!: FormGroup;
  public opcionForm!: FormGroup;

  public encuesta: EncuestaDTO | null = null;
  private pregunta: PreguntaDTO | null = null;
  public opcionesRespuesta: OpcionRespuestaDto[] = [];

  private formValues: any = null;
  public fieldType: string = '';

  public allowedTypes: FormFieldOption[] = [];

  public estados: FormFieldOption[] = [];

  public abiertaOpciones: FormFieldOption[] = [];
  public fieldsPregunta: FormField[] = [];

  public tableText: any = {};
  public crearPreguntaTexto: string = '';
  public actualizarPreguntaTexto: string = '';
  public opcionesRespuestaTexto: string = '';
  public agregarOpcion: string = '';
  public guardarText: string = '';
  public insertarOpcion: string = '';

  fieldFormPregunta!: FormGroup;

  constructor(
    private readonly utilService: UtilService,
    private readonly encuestaService: EncuestaService,
    public activeModal: NgbActiveModal,
    private readonly fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService
  ) { }

  ngOnInit(): void {
    this.translate.stream('encuestas').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }

      this.crearPreguntaTexto = this.tableText['crear-pregunta'];
      this.actualizarPreguntaTexto = this.tableText['actualizar-pregunta'];
      this.opcionesRespuestaTexto = this.tableText['opciones'];
      this.agregarOpcion = this.tableText['agregar-opcion'];
      this.guardarText = this.tableText['guardar'];
      this.insertarOpcion = this.tableText['insertar-opcion'];
      this.initFields();
    });

    this.preguntaForm = this.fb.group({
      opciones: this.fb.array([]),
    });

    this.pregunta = this.utilService.getPregunta();
    this.encuesta = this.utilService.getEncuesta();

    if (this.pregunta) {
      this.opcionesRespuesta = this.pregunta.Opcion_Respuesta_Pregunta || [];

      this.fieldsPregunta = this.fieldsPregunta.map((field: FormField) => {
        switch (field.name) {
          case 'descripcion':
            field.value = this.pregunta?.Descripcion;
            break;
          case 'estado':
            field.value = this.pregunta?.Estado
              ? this.estados[0].Id
              : this.estados[1].Id;

            break;
          case 'tipoCampo':
            field.value =
              this.pregunta?.Tipo_Campo == 'radiobutton'
                ? this.allowedTypes[1].Id
                : this.allowedTypes[0].Id;
            break;
        }
        return field;
      });

      if (
        this.pregunta.Tipo_Campo === 'radiobutton' &&
        this.opcionesRespuesta.length > 0
      ) {
        this.opciones.clear();
        this.opcionesRespuesta.forEach(opcion => {
          this.opciones.push(
            this.fb.group({
              Id: [opcion.Id],
              Abierta: [opcion.Abierta],
              Descripcion: [opcion.Descripcion, Validators.required],
            })
          );
        });
      }
    }
  }

  initFields() {
    this.estados.push(
      {
        Id: 1,
        Nombre: this.tableText['estado-activo'],
      },
      {
        Id: 2,
        Nombre: this.tableText['estado-inactivo'],
      }
    );

    this.allowedTypes.push(
      {
        Id: 1,
        Nombre: this.tableText['texto-opcion'],
      },
      {
        Id: 2,
        Nombre: this.tableText['radio-opcion'],
      }
    );

    this.abiertaOpciones.push(
      {
        Id: 1,
        Nombre: this.tableText['yes'],
      },
      {
        Id: 2,
        Nombre: this.tableText['no'],
      }
    );

    this.fieldsPregunta = [
      {
        name: 'descripcion',
        label: this.tableText['descripcion'],
        type: 'text',
        required: true,
        width: '12',
        noConvertToUpperCase: true,
        errorMessages: { required: this.tableText['campo-requerido'] },
      },

      {
        name: 'estado',
        label: this.tableText['estado'],
        type: 'select',
        required: true,
        width: '6',
        options: this.estados,
        multiple: false,
        errorMessages: { required: this.tableText['campo-requerido'] },
      },
      {
        name: 'tipoCampo',
        label: this.tableText['tipo-campo'],
        type: 'select',
        required: true,
        width: '6',
        options: this.allowedTypes,
        errorMessages: { required: this.tableText['campo-requerido'] },
      },
    ];
  }

  get opciones() {
    return this.preguntaForm.get('opciones') as FormArray;
  }

  onChangeForm(form: FormGroup) {
    this.fieldType =
      form.value.tipoCampo == 1
        ? 'text'
        : form.value.tipoCampo == 2
          ? 'radiobutton'
          : '';

    this.formValues = form.value;
    this.fieldFormPregunta = form;
  }

  onSubmitForm(form: FormGroup) {
    this.formValues = form.value;
  }

  addOption() {
    this.opciones.push(
      this.fb.group({
        Id: 0,
        Abierta: [true],
        Descripcion: ['', Validators.required],
      })
    );
  }

  removeOption(item: any) {
    this.opciones.removeAt(item);
  }

  guardarPreguntas() {
    this.activeModal.dismiss();
    let preguntaData: PreguntaDTO = {
      Descripcion: this.formValues.descripcion,
      Estado: this.formValues.estado == 1,
      Tipo_Campo: this.formValues.tipoCampo == 1 ? 'text' : 'radiobutton',
      Id: this.isNewItem ? 0 : this.pregunta?.Id!,
      Id_Encuesta: this.encuesta?.Id!,
    };

    if (this.formValues.tipoCampo == 2) {
      preguntaData.Opcion_Respuesta_Pregunta = this.opciones.value;
    }

    if (!this.isNewItem && this.pregunta) {
      preguntaData.Id = this.pregunta.Id;
      preguntaData.Id_Encuesta = this.pregunta.Id_Encuesta;
    }

    if (this.isNewItem) {
      this.encuestaService.crearPregunta(preguntaData).subscribe(() => {
        this.alertaModalService.exito(this.tableText['pregunta-creada']);
      });
    } else {
      this.encuestaService
        .actualizarPregunta(this.pregunta!.Id!, preguntaData)
        .subscribe(() => {
          this.alertaModalService.exito(this.tableText['pregunta-actualizada']);
        });
    }
  }

  validarFormulario() {
    if (this.fieldFormPregunta.get('tipoCampo')?.value != 2) {
      return this.fieldFormPregunta.invalid;
    } else {

      if (this.fieldFormPregunta.valid &&
        this.preguntaForm.valid &&
        (this.opciones.valid && this.opciones.length > 0)) {
        return false;
      } else {
        return true;
      }
    }
  }
}
